import React, { Component } from "react";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import "react-datepicker/dist/react-datepicker.css";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import addMonths from "date-fns/addMonths";
import subMonths from "date-fns/subMonths";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import { Messages } from "primereact/messages";
import * as appConst from "../../Common/constants";
import { Checkbox } from "primereact/checkbox";
import { SelectButton } from "primereact/selectbutton";
import { Dropdown } from "primereact/dropdown";

class AccountsAddEdit extends Component {
  constructor(props) {
    super(props);

    var _txnDate,
      _desc,
      _amount,
      _mode,
      _type,
      _name,
      _isReceipt,
      _paymentMode,
      _bankMode,
      _bankName,
      _txnNo,
      _chNo,
      _chdate,
      _chBank,
      _bankClass = "collapse",
      _chequeClass = "collapse",
      _transferClass = "collapse";
    if (this.props.pData._id == "NA") {
      _txnDate = "";
      _desc = "";
      _amount = 0.0;
      _type = "";
      _name = "";
      _mode = "add";
      _isReceipt = false;
      _paymentMode = "";
      _bankMode = "";
      _bankName = "";
      _txnNo = "";
      _chNo = "";
      _chdate = "";
      _chBank = "";
    } else {
      _desc = this.props.pData.desc;
      _amount =
        this.props.pData.amount < 0
          ? this.props.pData.amount * -1
          : this.props.pData.amount;
      _type = this.props.pData.type;
      _name = this.props.pData.name;
      _isReceipt = this.props.pData.isReceipt;
      _paymentMode = this.props.pData.paymentMode;
      _bankMode = this.props.pData.bankMode;
      _bankName = this.props.pData.bankName;
      _txnNo = this.props.pData.txnNo;
      _chNo = this.props.pData.chNo;
      _chBank = this.props.pData.chBank;
      _mode = "edit";

      _chdate =
        typeof this.props.pData.chdate === "undefined" ||
          this.props.pData.chdate === "" ||
          this.props.pData.chdate === null
          ? null
          : new Date(this.props.pData.chdate);
    }

    if (this.props.pData.paymentMode === "Bank") _bankClass = "row p-1 border";
    if (this.props.pData.bankMode === "Cheque") _chequeClass = "row p-1 border";
    else if (this.props.pData.bankMode === "Transfer")
      _transferClass = "row p-1 border";

    this.state = {
      txndate: _txnDate,
      desc: _desc,
      amount: _amount,
      type: _type,
      spinnerClass: "collapse",
      dataClass: "",
      mode: _mode,
      name: _name,
      isReceipt: _isReceipt,
      incomeTypeSuggestions: null,
      incomeTypeList: [],
      expTypeSuggestions: null,
      expTypeList: [],
      bankClass: _bankClass,
      chequeClass: _chequeClass,
      transferClass: _transferClass,
      Banks: [],
      paymentMode: _paymentMode,
      bankMode: _bankMode,
      bankName: _bankName,
      txnNo: _txnNo,
      chNo: _chNo,
      chdate: _chdate,
      chBank: _chBank
    };

    this.handleTxnDateChange = this.handleTxnDateChange.bind(this);
    this.handleReceiptChange = this.handleReceiptChange.bind(this);
    this.handleChDateChange = this.handleChDateChange.bind(this);
  }

  componentDidMount() {
    this.LoadIncomeType();
    this.LoadExpType();
    this.LoadBanks();
  }

  LoadBanks() {
    let _bankList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +

        "/Bank"
      )
      .then(response => {
        let bankData = response.data;

        bankData.forEach(function (item) {
          if (item.cash == false) {
            var obj = { label: item.name, value: item.name };
            _bankList.push(obj);
          }
        });
        this.setState({ Banks: _bankList });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  LoadIncomeType() {
    let _incomeTypeList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +

        "/incomeType/getIncomeTypes"
      )
      .then(response => {
        let typeData = response.data;
        typeData.forEach(function (item) {
          _incomeTypeList.push(item.incomeType);
        });
        this.setState({ incomeTypeList: _incomeTypeList });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  suggestIncomeType(event) {
    let results = this.state.incomeTypeList.filter(t => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });

    this.setState({ incomeTypeSuggestions: results });
  }

  LoadExpType() {
    let _expTypeList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +

        "/expType/getExpenseTypes"
      )
      .then(response => {
        let typeData = response.data;
        typeData.forEach(function (item) {
          _expTypeList.push(item.expType);
        });
        this.setState({ expTypeList: _expTypeList });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  suggestExpType(event) {
    let results = this.state.expTypeList.filter(t => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });

    this.setState({ expTypeSuggestions: results });
  }

  render() {
    const PaymentModes = [
      { label: "Cash", value: "Cash" },
      { label: "Bank", value: "Bank" }
    ];

    const BankModes = [
      { label: "Cheque", value: "Cheque" },
      { label: "Transfer", value: "Transfer" }
    ];

    return (
      <div>
        <div className={this.getHeaderClass()}>
          <h4 align="center"> {this.getHeading()}</h4>
        </div>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid">
            {/* <div className="row p-1 border">
              <div className="col col-md-2"></div>
              <div className="col col-md-10">
                <Checkbox
                  onChange={this.handleReceiptChange}
                  checked={this.state.isReceipt}
                ></Checkbox>
                <label htmlFor="cb1" className="p-checkbox-label">
                  <b>{this.getReceiptLabel()}</b>
                </label>
              </div>
            </div> */}
            <div className={this.getTxnDateClass()}>
              <div className="col col-md-2">Txn Date</div>
              <div className="col col-md-3">
                <DatePicker
                  selected={this.state.txndate}
                  onChange={this.handleTxnDateChange}
                  dateFormatCalendar={"MMM yyyy"}
                  minDate={subMonths(new Date(), 10)}
                  maxDate={new Date()}
                  showMonthYearDropdown
                  dateFormat="dd-MMM-yyyy"
                  width="300px"
                  // style={{ width: "300px" }}
                  className="p-error"
                />
              </div>
            </div>
            <div className={this.getNameClass()}>
              <div className="col col-md-2">Name</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  value={this.state.name}
                  onChange={e => this.setState({ name: e.target.value })}
                  style={{ width: "300px" }}
                  className="p-error"
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Description</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  value={this.state.desc}
                  onChange={e => this.setState({ desc: e.target.value })}
                  style={{ width: "300px" }}
                  className="p-error"
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">{this.props.txnType} Type</div>
              <div className={this.getIncomeClass()}>
                <AutoComplete
                  value={this.state.type}
                  onChange={e => this.setState({ type: e.value })}
                  suggestions={this.state.incomeTypeSuggestions}
                  completeMethod={this.suggestIncomeType.bind(this)}
                  size={38}
                  className="p-error"
                />
              </div>
              <div className={this.getExpenseClass()}>
                <AutoComplete
                  value={this.state.type}
                  onChange={e => this.setState({ type: e.value })}
                  suggestions={this.state.expTypeSuggestions}
                  completeMethod={this.suggestExpType.bind(this)}
                  size={38}
                  className="p-error"
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">{this.props.txnType} Amount</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  keyfilter="money"
                  value={this.state.amount}
                  onChange={e => this.setState({ amount: e.target.value })}
                  style={{ width: "300px" }}
                  className="p-error"
                />
              </div>
            </div>

            <div className="row p-1 border">
              <div className="col col-md-2">Payment Mode</div>
              <div className="col col-md-3">
                <SelectButton
                  value={this.state.paymentMode}
                  options={PaymentModes}
                  onChange={this.onPaymentModeChange}
                  className="p-error"
                />
              </div>
            </div>
            <div className={this.state.bankClass}>
              <div className="col col-md-2">Bank Txn Mode</div>
              <div className="col col-md-3">
                <SelectButton
                  value={this.state.bankMode}
                  options={BankModes}
                  onChange={this.onBankModeChange}
                  className="p-error"
                />
              </div>
            </div>
            <div className={this.state.bankClass}>
              <div className="col col-md-2">Select Bank</div>
              <div className="col col-md-3">
                <Dropdown
                  value={this.state.bankName}
                  options={this.state.Banks}
                  placeholder="Select Bank"
                  onChange={this.onBankChange}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className={this.state.chequeClass}>
              <div className="col col-md-2"></div>
              <div className="col col-md-10">
                <div className="row p-1 ">
                  <div className="col col-md-1 border">Number</div>
                  <div className="col col-md-3 border">
                    <InputText
                      type="text"
                      value={this.state.chNo}
                      onChange={e => this.setState({ chNo: e.target.value })}
                      style={{ width: "200px" }}
                    />
                  </div>
                  <div className="col col-md-1 border">Date</div>
                  <div className="col col-md-3 border">
                    <DatePicker
                      selected={this.state.chdate}
                      onChange={this.handleChDateChange}
                      dateFormatCalendar={"MMM yyyy"}
                      minDate={subMonths(new Date(), 6)}
                      maxDate={addMonths(new Date(), 6)}
                      showMonthYearDropdown
                      dateFormat="dd-MMM-yyyy"
                      width="300px"
                    />
                  </div>
                  <div className="col col-md-1 border">Bank</div>
                  <div className="col col-md-3 border">
                    <InputText
                      type="text"
                      value={this.state.chBank}
                      onChange={e => this.setState({ chBank: e.target.value })}
                      style={{ width: "200px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={this.state.transferClass}>
              <div className="col col-md-2"></div>
              <div className="col col-md-10">
                <div className="row p-1 ">
                  <div className="col col-md-2 border">Txn No</div>
                  <div className="col col-md-3 border">
                    <InputText
                      type="text"
                      value={this.state.txnNo}
                      onChange={e => this.setState({ txnNo: e.target.value })}
                      style={{ width: "200px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row p-1 border">
              <button
                onClick={this.onSaveClick}
                className="btn btn-primary btn-md mr-2"
              >
                Save
              </button>
              <button
                onClick={this.onClearClick}
                className="btn btn-primary btn-md mr-2"
              >
                Clear
              </button>
              <button
                onClick={this.onCancelClick}
                className={this.getCancelClass()}
              >
                Cancel
              </button>
            </div>
            <Growl ref={el => (this.growl = el)} />
            <Messages ref={el => (this.messages = el)} />
          </div>
        </div>
      </div>
    );
  }

  onBankChange = e => {
    this.setState({ bankName: e.target.value });
  };

  onPaymentModeChange = e => {
    this.setState({ paymentMode: e.value });
    if (e.value === "Bank") this.setState({ bankClass: "row p-1 border" });
    else this.setState({ bankClass: "collapse" });

    this.setState({
      chequeClass: "collapse",
      transferClass: "collapse",
      bankMode: ""
    });
  };

  onBankModeChange = e => {
    this.setState({ bankMode: e.value });
    if (e.value === "Cheque")
      this.setState({
        chequeClass: "row p-1 border",
        transferClass: "collapse"
      });
    else
      this.setState({
        chequeClass: "collapse",
        transferClass: "row p-1 border"
      });

    this.setState({
      chBank: "",
      chNo: "",
      chdate: "",
      txnNo: ""
    });
  };

  getCancelClass() {
    let clsName = "btn btn-primary btn-md mr-2 ";
    if (this.props.source === "list") {
      clsName += "visible";
    } else {
      clsName += "invisible";
    }
    return clsName;
  }

  getTxnDateClass() {
    let clsName = "row p-1 border ";
    if (this.props.pData._id != "NA") clsName += "collapse";

    return clsName;
  }

  getNameClass() {
    let clsName = "row p-1 border ";
    if (this.state.isReceipt === false) clsName += "collapse";

    return clsName;
  }

  handleTxnDateChange(txndate) {
    this.setState({ txndate });
  }

  handleChDateChange(chdate) {
    this.setState({ chdate });
  }

  handleReceiptChange(e) {
    this.setState({ isReceipt: e.checked });
  }

  getHeading() {
    if (this.props.pData._id == "NA") return "Add " + this.props.txnType;
    else return "Edit " + this.props.txnType;
  }

  getReceiptLabel() {
    if (this.props.txnType === "Income") return "Issue Receipt";
    else return "Issue Voucher";
  }

  getHeaderClass() {
    if (this.props.txnType === "Income") return "bg-success text-white p-1";
    else return "bg-warning text-white p-1";
  }

  getIncomeClass() {
    if (this.props.txnType === "Income") return "col col-md-3";
    else return "col col-md-3 collapse";
  }

  getExpenseClass() {
    if (this.props.txnType === "Expense") return "col col-md-3";
    else return "col col-md-3 collapse";
  }

  onSaveClick = e => {
    e.preventDefault();
    if (
      this.state.txndate === "" ||
      this.state.desc === "" ||
      this.state.type === "" ||
      this.state.paymentMode === ""
    ) {
      this.messages.show({
        severity: "error",
        summary: "Error !!",
        detail: "Select Mandatory Fields"
      });
    } else {
      const obj = {
        txndate: this.state.txndate,
        desc: this.state.desc,
        type: this.state.type,
        amount: this.state.amount,
        txntype: this.props.txnType,
        name: this.state.name,
        isReceipt: this.state.isReceipt,
        paymentMode: this.state.paymentMode,
        bankMode: this.state.bankMode,
        bankName: this.state.bankName,
        txnNo: this.state.txnNo,
        chNo: this.state.chNo,
        chdate: this.state.chdate,
        chBank: this.state.chBank
      };

      if (this.props.txnType === "Expense") obj.amount *= -1;

      if (this.state.mode === "add") {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +

            "/account/add",
            obj
          )
          .then(res => {
            if (this.state.isReceipt) this.props.onClick("Print", res.data);
            else this.props.onClick("List", "");
          });
        this.ClearData();
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: this.props.txnType + " Added !!!"
        });
      } else {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +

            "/account/update/" +
            this.props.pData._id,
            obj
          )
          .then(res => {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: this.props.txnType + " Updated !!!"
            });
            this.props.onClick("List", null);
          });
      }
    }
  };

  ClearData() {
    this.setState({
      txndate: "",
      desc: "",
      type: "",
      amount: 0,
      receipt: false,
      name: "",
      paymentMode: "",
      bankMode: "",
      chBank: "",
      chNo: "",
      chdate: "",
      txnNo: ""
    });
  }

  onClearClick = e => {
    this.ClearData();
    this.growl.show({
      severity: "success",
      summary: "Success",
      detail: "Data Cleared !!!"
    });
  };

  onCancelClick = e => {
    this.props.onClick("List", null);
  };
}

export default AccountsAddEdit;
